import { createActions, createReducer } from 'reduxsauce';

// ACTION TYPES + CREATORS
const { Types, Creators } = createActions(
  {
    // Products
    getProducts: [],
    getProductsRequest: [],
    getProductsSuccess: ['response'],
    getProductsFailure: ['error'],

    // Pay By Points
    payByPoints: ['payload', 'resolve'],
    payByPointsRequest: [],
    payByPointsSuccess: ['response'],
    payByPointsFailure: ['error'],
  },
  { prefix: 'cb/products/' }
);

// INITIAL STATE
export const INITIAL_STATE = {
  products: [],

  // stores successful pay-by-points response
  payByPoints: null,

  loading: {
    products: false,
    payByPoints: false,
  },

  error: {
    products: null,
    payByPoints: null,
  },
};

// REDUCERS
export const HANDLERS = {
  // -----------------------------
  // GET PRODUCTS
  // -----------------------------
  [Types.GET_PRODUCTS_REQUEST]: (state) => ({
    ...state,
    loading: {
      ...state.loading,
      products: true,
    },
    error: {
      ...state.error,
      products: null,
    },
  }),

  [Types.GET_PRODUCTS_SUCCESS]: (state, { response }) => ({
    ...state,
    products: response,
    loading: {
      ...state.loading,
      products: false,
    },
  }),

  [Types.GET_PRODUCTS_FAILURE]: (state, { error }) => ({
    ...state,
    loading: {
      ...state.loading,
      products: false,
    },
    error: {
      ...state.error,
      products: error,
    },
  }),

  // -----------------------------
  // PAY BY POINTS
  // -----------------------------
  [Types.PAY_BY_POINTS_REQUEST]: (state) => ({
    ...state,
    payByPoints: null,
    loading: {
      ...state.loading,
      payByPoints: true,
    },
    error: {
      ...state.error,
      payByPoints: null,
    },
  }),

  [Types.PAY_BY_POINTS_SUCCESS]: (state, { response }) => ({
    ...state,
    payByPoints: response,
    loading: {
      ...state.loading,
      payByPoints: false,
    },
  }),

  [Types.PAY_BY_POINTS_FAILURE]: (state, { error }) => ({
    ...state,
    payByPoints: null,
    loading: {
      ...state.loading,
      payByPoints: false,
    },
    error: {
      ...state.error,
      payByPoints: error,
    },
  }),
};

export default createReducer(INITIAL_STATE, HANDLERS);

export { Types as types, Creators as actions };